<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="700px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
            <span class="px-3">{{ $t('All Balance') }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <v-layout row wrap pa-2>
          <v-flex xs12 pa-2>
            <h3>{{ $t('Cash Balance') }}</h3>
          </v-flex>

          <v-flex xs12 style="margin-bottom:20px">
            <v-layout row wrap class="view-table-header">
              <v-flex xs1 pa-2>#</v-flex>
              <v-flex xs5 pa-2>{{ $t('Name') }}</v-flex>
              <v-flex xs3 pa-2>{{ `${$t('Amount')} (USD)` }}</v-flex>
              <v-flex xs3 pa-2>{{ `${$t('Amount')} (IQD)` }}</v-flex>
            </v-layout>

            <v-layout row wrap v-if="viewInfo.cash_balance">
              <v-flex class="view-table-row" xs1>
                <p class="view-table-content">{{ 1 }}</p>
              </v-flex>
              <v-flex class="view-table-row" xs5>
                <p class="view-table-content">
                  {{ $t('Cash Balance') }}
                </p>
              </v-flex>
              <v-flex class="view-table-row" xs3>
                <p class="view-table-content">
                  {{ viewInfo.cash_balance.amount_us | currency }}
                </p>
              </v-flex>
              <v-flex class="view-table-row" xs3>
                <p class="view-table-content">
                  {{ viewInfo.cash_balance.amount_iq | currency }}
                </p>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 pa-2>
            <h3>{{ $t('Cashiers Balance') }}</h3>
          </v-flex>

          <v-flex xs12 style="margin-bottom:20px">
            <v-layout row wrap class="view-table-header">
              <v-flex xs1 pa-2>#</v-flex>
              <v-flex xs5 pa-2>{{ $t('Name') }}</v-flex>
              <v-flex xs3 pa-2>{{ `${$t('Amount')} (USD)` }}</v-flex>
              <v-flex xs3 pa-2>{{ `${$t('Amount')} (IQD)` }}</v-flex>
            </v-layout>

            <template v-if="viewInfo.cashiers && viewInfo.cashiers.length > 0">
              <v-layout row wrap v-for="(row, index) in viewInfo.cashiers" :key="index">
                <v-flex class="view-table-row" xs1>
                  <p class="view-table-content">{{ index + 1 }}</p>
                </v-flex>
                <v-flex class="view-table-row" xs5>
                  <p class="view-table-content">
                    {{ row.main_cashier_name }}
                  </p>
                </v-flex>
                <v-flex class="view-table-row" xs3>
                  <p class="view-table-content">
                    {{ row.amount_us | currency }}
                  </p>
                </v-flex>
                <v-flex class="view-table-row" xs3>
                  <p class="view-table-content">
                    {{ row.amount_iq | currency }}
                  </p>
                </v-flex>
              </v-layout>
            </template>
          </v-flex>

          <v-layout row wrap style="margin-top:20px" v-if="viewInfo">
            <v-flex class="view-table-row top-border" xs6>
              <p class="view-table-content">
                <strong>{{ $t('Total Balance') }}</strong>
              </p>
            </v-flex>
            <v-flex class="view-table-row top-border" xs3>
              <p class="view-table-content">
                <strong>{{ viewInfo.total_us | currency }}</strong>
              </p>
            </v-flex>
            <v-flex class="view-table-row top-border" xs3>
              <p class="view-table-content">
                <strong>{{ viewInfo.total_iq | currency }}</strong>
              </p>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Close') }}</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'view-component',

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency
    }
  },

  computed: {
    ...mapGetters({
      viewInfo: 'dashboard/getAllBalance'
    })
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    }
  }
}
</script>

<style scoped>
.top-border {
  border-top-style: solid;
}
</style>
